@if (playoutAggregation) {

  <div [ngbTooltip]="playout"
       class="tw-flex tw-w-fit tw-text-sbBlue-500 dark:tw-text-white dark:tw-bg-sbGrayBlue-800 tw-rounded-full tw-bg-sbBlue-50 tw-py-2 tw-px-4"
       tooltipClass="widthFix">
    {{ playoutAggregation?.productivePlayouts | sbNumberFormat }}
  </div>
} @else {
  {{ 'lang.globals.noData' | translate }}
}
<ng-template #playout>
  <div style="min-width: 300px">
    <ul>
      <li class="tw-flex tw-flex-nowrap">Prod. Playouts: {{ playoutAggregation?.productivePlayouts| sbNumberFormat }}</li>
      <li class="tw-flex tw-flex-nowrap">Prod.
        Playbacktime: {{ dateTransformation.parseTimeToDuration(playoutAggregation?.productivePlaybacktime) }}
      </li>
      <li class="tw-flex tw-flex-nowrap">Non-Prod. Playouts: {{ playoutAggregation?.nonProductivePlayouts| sbNumberFormat }}</li>
      <li class="tw-flex tw-flex-nowrap">Non-Prod.
        Playbacktime: {{ dateTransformation.parseTimeToDuration(playoutAggregation?.nonProductivePlaybacktime) }}
      </li>
    </ul>
  </div>
</ng-template>
